import { Bus } from '@/event-bus.js'
import Vue from 'vue'

export default{
    setSoloGame: ({commit, dispatch}, soloGame) => {
        commit('setSoloGameState', soloGame)
        Bus.$emit('nextSoloGame')
    },
    setGameSetId: ({commit}, gameSetId) => {
        commit('setGameSetIdState', gameSetId)
        localStorage.setItem('gameSetId', gameSetId)
        // console.log('VUEX Get: ', gameSetId)
    },
    getSoloGame: ({commit, dispatch}) => {
        let gameSetId = localStorage.getItem('gameSetId')
        if(gameSetId){
            Vue.http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`)
               .then(response => {
                   commit('setSoloGameRequest', response.body);
                   localStorage.setItem('Solo-game', response.body)
                   Bus.$emit('saveSoloGame')
                })
                // console.log('Solo game ID: ', response.body)
        }
    },
}

    
